import { Tent } from "lucide-react"
import one from "../assets/images/s1.jpg"
import two from "../assets/images/s2.jpg"
import three from "../assets/images/s3.jpg"
import four from "../assets/images/s4.jpg"
import five from "../assets/images/s5.jpg"
import guidelines from "../assets/images/s6.jpg"
import Publication from "../assets/images/s7.jpg"
import Leaders from "../assets/images/s8.jpg"
import Clinical from "../assets/images/s9.jpg"
import website from "../assets/images/website.webp"
import ten from "../assets/images/ten.webp"
export const servicesData = [
  {
    id: 1,
    title: "Key Opinion Leaders (KOL) Identification",
    image: one,
    direction: "left", // image left, text right
    description: [
      `Identifying Key Opinion Leaders KOLs in the healthcare sector involves a strategic approach due to the sector's complexity and high standards for credibility and expertise. Prognoza Dataminds conducts thorough research to identify influential thought leaders in the healthcare sector, including physicians, hospital executives, researchers, investigators, directors, and more. The major steps in KOL identification are as follows:`,

      `Define the objectives: Determine what you want to achieve e.g., clinical trial recruitment, product endorsement, thought leadership. Identify the specific healthcare professionals, patients, or stakeholders you aim to reach.`,
      `Understand the Healthcare Landscape: Recognize the relevant medical specialties or therapeutic areas`,
      `Identify KOLs Using Multiple Channels like Medical Conferences and Journals; Professional Associations; Academic Institutions; Online Platforms`,
      `Evaluate Their Influence and Credibility using Publication Record; Clinical Experience; Professional Reputation; Media Presence`,
      `Our team possesses extensive experience in pinpointing key leaders through precise methods and techniques. We have developed specialized tools to collect information from diverse sources such as publications, clinical trials, guidelines, and other relevant areas.`
    ]
  },
  {
    id: 2,
    title: "Profiling of Key Opinion Leaders KOLs",
    image: two,
    direction: "right", // image right, text left
    description: [
      `Key Opinion Leaders KOLs profiling in healthcare involves identifying and assessing Key Opinion Leaders KOLs who hold significant influence in the medical and healthcare sectors. These individuals play a vital role in shaping clinical practices, impacting healthcare policy, advancing research, and driving innovation.`,

      `The primary KPIs in our KOL profiling encompass Conferences, Publications, Clinical Trials, Editorial Boards, Advisory Boards, Guidelines, Committees, Social Media Engagement, Affiliations, Awards, and Honors, among others.`,
      `Components of the Profile:`,
    ],
    points: [
      "Personal Information: Background, current role, and professional affiliations.",
      "Expertise and Achievements: Detailed account of their clinical, academic, and research accomplishments.",
      "Influence Metrics: Data on their reach, impact, and engagement across various channels.",
      "Previous Collaborations: History of past partnerships and outcomes.",
      "Alignment Analysis: Evaluation of fit with your strategic goals and values."
    ],
    footer: `By thoroughly profiling KOLs, we can make informed decisions about which influential figures to engage with, ensuring that their expertise, influence, and values align with your strategic goals in the healthcare sector.`
  },
   ,
  {
    id: 3,
    title:"KOL Mapping and Analysis",
    image: three,
    direction: "left", // image left, text right
    description: [
      `KOL mapping and analysis in healthcare is a strategic process that involves identifying, evaluating, and understanding the network and influence of Key Opinion Leaders (KOLs) in the medical field. This process enables the strategic use of their expertise and influence to advance research, boost product adoption, and shape healthcare policies.`,

      `The expert team at Prognoza Dataminds assesses KOL influence and impact by identifying their connections, such as collaborations, co-authorships, and professional associations. We map how KOLs are linked to other experts, institutions, and stakeholders within the healthcare sector, considering both regional and global networks and their potential effects on healthcare practices. Our search strategies for KOL mapping include leveraging research databases such as publications and clinical trials, medical conferences, medical associations, and social media platforms.`,
    ]
  },{
    id: 4,
    title: "Conference Coverage",
    image: ten,
    direction: "right", // image right, text left
    description: [
    `Prognoza provide live conference coverage services, capturing and tracking conference content in real time, including posters, oral presentations, symposiums, and key scientific updates. Our team ensures timely collection, extraction, and delivery of relevant information throughout the conference duration, enabling clients to stay updated on critical developments as they occur. Our team has extensive experience in covering leading medical conferences, including ASCO, AACR, ASH, ESMO, ERS and many others, providing comprehensive conference coverage, high-quality content, and accurate insights.`]
    ,points: [
      "Real-time monitoring of conference sessions",
      "Coverage of oral, poster, and symposium sessions",
      "Poster and presentation capture",
      "Key data extraction and summarization",
      "Daily conference updates and reporting",
      "Tracking of late-breaking presentations and announcements",
      "Rapid turnaround of captured content",
      "Timely access to critical conference information",
      "Comprehensive coverage of relevant scientific content",
      "Improved competitive intelligence and market awareness",
      "Faster decision-making based on real-time insights",
      "Reduced internal resource requirements for conference monitoring",
      "Structured and searchable conference intelligence repository"
    ],
  }
 ,
  {
    id: 5,
    title:"Repository of Medical Conferences",
    image: four,
    direction: "left", // image left, text right
    description: [
      `A Medical Conferences Repository is a centralized database or platform where information about upcoming, ongoing, and past medical and healthcare conferences is collected and made accessible. Such repositories are invaluable for researchers, clinicians, and industry professionals seeking to stay updated on the latest advancements, network with peers, and participate in relevant discussions.`,
      `Our Subject Matter Experts Team oversees the Medical Conference Repository, which encompasses comprehensive event details such as dates, session topics, locations, event types, agendas, keynotes, speakers, presenters, specialties, and abstracts. The team is dedicated to regularly updating the database to ensure clients receive the most current information.`
    ]
  }, {
    id: 6,
    title: "Rising Star Analysis",
    image: five,
    direction: "right", // image right, text left
    description: [
      `Rising Star Analysis in the healthcare sector involves identifying emerging professionals or influencers who are on the path to becoming significant opinion leaders. These individuals, while not yet established KOLs Key Opinion Leaders, show potential due to their early achievements, innovative ideas, or growing influence in their respective fields.`,
      `Our team assesses these KOLs based on their early achievements, recognitions, and professional development, including research contributions, innovations, professional awards, grants, funding, and leadership roles.`,
      `By conducting a Rising Star Analysis, healthcare organizations can proactively identify and nurture emerging talent that has the potential to become influential leaders. This approach allows for early engagement, fostering relationships that can lead to future collaborations and contributions to the field.`,
      ``
    ]
  }, {
    id: 7,
    title: "Research on Guidelines",
    image: guidelines,
    direction: "left", // image left, text right
    description: [
      `Prognoza Dataminds conducts research and gathers medical practice guidelines influenced by Key Opinion Leaders. Our Guideline Database is systematically organized by industries, medical specialties, geographic locations, conditions, and other relevant categories` ],
  }, {
    id: 8,
    title: "Publication Analysis",
    image:Publication,
    direction: "right", // image right, text left
    description: [
      `Publication analysis on PubMed involves evaluating research articles and their impact in the scientific community. PubMed, a free search engine that comprises more than 37 million citations for biomedical literature from MEDLINE, life science journals, and online books is a key resource for such analysis. Prognoza Dataminds reviews each KOL's publications and maintains a comprehensive database that includes details such as title, research focus, authors, journal or conference name, publication date, volume, abstracts, and collaborators.`,
    `Our team analyzes this publication data to identify trends in KOL engagement, which plays a key role in our KOL ranking process. The steps involved in the analysis include:`],
    points: [
      `ormulate proper “Search Query” MeSH terms related to the disease condition or therapeutic area under consideration.`,
      `Conduct Search on the PubMed`,
      `Analyze Top authors and Publications`,
      `Examine Author contributions like frequency and the list for most recent and impactful studies`,
   `Assess impact and influence`
    ],
    footer: `By following these steps, Prognoza Dataminds can effectively use PubMed to identify and analyze KOLs, providing valuable insights into leading researchers and their influence within a specific field.`

  }, {
    id: 9,
    title: "Clinical Trial Analysis",
    image: Clinical,
    direction: "left", // image left, text right
    description: [
      `Clinical Trial Analysis is a crucial process for assessing the efficacy, safety, and overall impact of medical interventions. Prognoza Dataminds specializes in identifying and providing visibility into clinical trial data. Our team uses several clinical trials database across the globe to conduct search. The steps involved in the process include:`,
    ],
    points: [
      `Defining Search Query;`,
      `Conducting Search on the database;`,
      `Review/Analysis of the search results;`,
      `Identify Key Players and Innovations`,
    ],
    footer: `Our team manages a comprehensive Clinical Trial Database that includes key details such as trial IDs, status, sponsors, collaborators, dates, and researchers. We regularly update trial statuses and prepare detailed clinical trial reports to support clients in making informed KOL ranking decisions.`

  },
   {
    id: 10,
    title: "Market Access Identification/ Profiling",
    image: Leaders,
    direction: "right", // image right, text left
    description: [
      `Market Access Identification/ Profiling is essential for organizations to effectively introduce and optimize new healthcare products, such as pharmaceuticals, biotech innovations, and medical devices, in various markets. The touch points for Market access are:`],
    points: [`Pricing, Reimbursement & Market Access Committees – committee members, working groups and external experts`,
      `Public & Private Payers`,
      `HTA Guideline Committees - guideline participants`,
      `HTA committees - committee members, working groups and external experts`,
      `Public Health Associations - executive members and sub-committees`,
      `Publications - Health & Pricing related`,
      `Journals - editorial board and reviewers`,
      `Government Advisory Boards`
    ]
  },{
    id: 11,
    title: "Medical Website Developments",
    image: website,
    direction: "left", // image left, text right
    description: [
      `Transform Your Medical Practice with a Modern, Patient-Friendly Website:`],
    points: [`In today’s digital-first world, patients search online before choosing a doctor or healthcare provider.`,
      `A well-designed medical website not only enhances your professional reputation but also helps patients connect with you easily and confidently.`,
      `Prognoza specialize in creating clean, modern, secure, and fully responsive medical websites tailored to the needs of doctors, clinics, and healthcare organizations.`
    ]
  }
  // Continue adding other services (Mapping, Conferences, Rising Star, etc.)
];
